import PropTypes from 'prop-types';

import FormTemplateWorkflowCard from '../presentational/FormTemplateWorkflowCard/FormTemplateWorkflowCard';
import { FormTemplateError } from './FormTemplateError';

function FormTemplateWorkflowList(props) {
  const {
    workflowDefinitions,
    requestLoading,
    requestError = undefined,
    onSelect,
    formsExist,
    signaturesEnabled = undefined,
    selectedWorkflowDefinitionId = undefined,
  } = props;

  // const NUMBER_OF_PLACEHOLDERS = 4;
  const NUMBER_OF_PLACEHOLDERS = 2;

  const getPlaceholderWokflowDefinition = (id) => ({
    id: id,
    name: 'Loading...',
    description: 'Loading...',
  });

  const isDisabled = (workflowDefinition) => {
    return formsExist || (!signaturesEnabled && workflowDefinition.with_signature);
  };

  const getTooltipText = (workflowDefinition) => {
    if (isDisabled(workflowDefinition)) {
      if (formsExist) {
        return 'Workflows cannot be changed once a form has been created with a template';
      }

      if (!signaturesEnabled && workflowDefinition.with_signature) {
        return 'Signatures are not currently enabled on this trial';
      }
    }

    return undefined;
  };

  const displayError = () => {
    return requestError && Object.entries(requestError).length > 0;
  };

  if (requestLoading) {
    return (
      <div className="form-template-workflow-list">
        {[...Array(NUMBER_OF_PLACEHOLDERS).keys()]
          .map((index) => getPlaceholderWokflowDefinition(index + 1))
          .map((workflowDefinition) => {
            return (
              <FormTemplateWorkflowCard
                key={workflowDefinition.id}
                workflowDefinition={workflowDefinition}
                selectedWorkflowDefinitionId={0}
                disabled
                loading
              />
            );
          })}
      </div>
    );
  }

  if (!displayError()) {
    return (
      <div className="form-template-workflow-list">
        {workflowDefinitions.map((workflowDefinition) => {
          return (
            <FormTemplateWorkflowCard
              key={workflowDefinition.id}
              workflowDefinition={workflowDefinition}
              selectedWorkflowDefinitionId={selectedWorkflowDefinitionId}
              disabled={isDisabled(workflowDefinition)}
              tooltipText={getTooltipText(workflowDefinition)}
              onSelect={onSelect}
            />
          );
        })}
      </div>
    );
  }

  return <FormTemplateError source="api" handleLog customError={requestError} disableWrapperClass />;
}

FormTemplateWorkflowList.propTypes = {
  workflowDefinitions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  requestLoading: PropTypes.bool.isRequired,
  requestError: PropTypes.shape({
    name: PropTypes.string,
    message: PropTypes.string,
  }),
  onSelect: PropTypes.func.isRequired,
  formsExist: PropTypes.bool.isRequired,
  signaturesEnabled: PropTypes.bool,
  selectedWorkflowDefinitionId: PropTypes.number,
};

export default FormTemplateWorkflowList;
